import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import jobs from "@src/api/jobs/jobs";
import Panel from "@src/components/box/Panel";
import SuggestionsHeader from "@src/components/elements/sidebar/suggestions/SuggestionsHeader";
import SuggestionsItem from "@src/components/elements/sidebar/suggestions/SuggestionsItem";
import { useInfiniteQueryOnScroll } from "@src/hooks/useInfiniteQueryOnScroll";

type Props = { key?: string };

const Suggestions: FC<Props> = () => {
  const { t } = useTranslation();
  const [searchQuery] = useState("");
  const queryParams = {
    q: searchQuery,
  };
  const { result: jobsResult } = useInfiniteQueryOnScroll({
    queryKey: ["jobs", searchQuery],
    queryFn: ({ pageParam }) => jobs({ params: { ...queryParams, page: pageParam } }),
    initialPageParam: 0,
    getNextPageParam: lastPage => {
      const nextPage = lastPage.current_page + 1;
      return nextPage <= lastPage.total_pages ? nextPage : null;
    },
  });
  const jobsList = jobsResult.isSuccess
    ? jobsResult.data.pages.flatMap(page => page.data).filter(job => job !== null)
    : [];
  return (
    <Panel title={t("main.recommendations.title")}>
      <div className="grid grid-cols-1 gap-2">
        <SuggestionsHeader
          text={t("main.recommendations.jobs")}
          action={t("buttons.publish")}
          link="/jobs/jobs_erstellen"
        />
        {jobsList.slice(0, 3).map(item => (
          <SuggestionsItem
            key={item.title}
            name={item.title}
            link={"jobs/" + item.id}
            picture={item.user.avatar_url ?? `/images/placeholder/${item.user.type}.png`}
          />
        ))}
        <NavLink
          to={"jobs/für_dich"}
          className="mt-3 w-full rounded-full bg-gray-200 py-1 text-center text-xs hover:bg-gray-300"
        >
          {t("buttons.showMore")}
        </NavLink>
      </div>
    </Panel>
  );
};
export default Suggestions;
